<template>
  <Loading :loading="isLoading">
    <div v-if="error">
      {{error}}
    </div>
    <WordpressDisplayContent
      v-else
      :pageData="this.pageData"
    />
  </Loading>
</template>

<script>
import { fetchWordpressContent } from "../network/wordpressRequests";
import Loading from "@/components/loading/Loading";

import WordpressDisplayContent from './WordpressDisplayContent'

export default {
  name: "WordpressContentPage",
  components: {
    Loading,
    WordpressDisplayContent
  },
  //page slug is the slug of the page to show, show loading is weather to show loading indicator
  props: ["pageSlug", "showLoading"],
  data: () => {
    return {
      pageData: null,
      loading: true,
      error: null
    };
  },
  created() {
    this.loadData();
    if (this.pageSlug == "home") {
      let referral_code = this.$route.query.referral
      if(referral_code){
        sessionStorage.setItem("cherry_tree_referral", referral_code);
        // console.log(sessionStorage)
      }
    }
  },
  methods: {
    loadData() {
      this.loading = true;
      this.error = "";
      // Check login status before loading data
      this.$store.dispatch("auth/checkLogin").then(loggedIn => {
        let slug = this.pageSlug;
        fetchWordpressContent(
          { slug: slug, loggedIn: loggedIn }, //id of page in wordpress
          result => {
            this.pageData = result;
            this.loading = false;
          },
          (error) => { //on error
            this.error = "Error loading content";
            console.log(error)
            //reload
            setTimeout(() => {this.loadData()}, 2000)
          }
        );
      });
    }
  },
  computed: {
    isLoading() {
      if (this.showLoading === false) {
        return false;
      } else {
        return this.loading;
      }
    }
  },
  watch: {
    loading() {
      //if loading event happens, emeit loaded event
      //allows container components to show loading icon for wordpress content
      this.$emit("loaded");
    },
    //update data whenever a parameter changes
    pageSlug() {
      this.loadData();
    }
  }
};
</script>

<style lang="scss">

</style>
